import React from "react";
import Tilt from "react-tilt";
import styled from "styled-components";
// import { motion } from "framer-motion";

// import { styles } from "../styles";
import github from "../../assets/github.png";
import { CommonSection, CommonSubTitle, CommonTitle, Grid } from "../../common/styles";
import { projects } from "../../utils/data";
import { ProjectContent, SkillContent, SkillTitle } from "../skills/styles";

const ProjectCard = ({
    index,
    name,
    description,
    key_techs,
    image,
    source_code_link,
    category
}) => {
    return (
        <Tilt
            options={{
                max: 45,
                scale: 1,
                speed: 450,
            }}
        // className='bg-[#FFFFFF] rounded-2xl sm:w-[360px] w-full'
        >
            <ProjectContent>
                <div className='relative w-full h-[230px]'>
                    <img
                        src={image}
                        alt='project_image'
                        className='w-full h-full object-fill rounded-2xl'
                    />

                    <div className='absolute right-0 bottom-0 flex justify-end m-3'>
                        <div
                            onClick={() => window.open(source_code_link, "_blank")}
                            className='black-gradient bg-gradient-to-r from-blue-500 to-black w-10 h-10 rounded-full flex justify-center items-center cursor-pointer'
                        >
                            <img
                                src={github}
                                alt='source code'
                                className='w-full object-contain '
                            />
                        </div>
                    </div>
                </div>

                <div className='mt-5'>
                    {/* <h3 className='text-[#757575] font-bold text-[24px]'>{name}</h3> */}
                    <SkillTitle>
                        {name}
                    </SkillTitle>
                    <p className='mt-2 text-secondary text-[14px]'>{description}</p>
                </div>

                <div className='mt-4 flex flex-wrap gap-2'>
                    {key_techs.map((tag) => (
                        <p
                            key={`${tag}`}
                            className={`text-[14px]`}
                        >
                            #{tag}
                        </p>
                    ))}
                </div>
            </ProjectContent >
        </Tilt>
    );
};

const Projects = () => {
    return (
        <CommonSection id="skills">
            <CommonTitle>Projects</CommonTitle>
            <CommonSubTitle>My technical level</CommonSubTitle>

            <SkillsContainer>
                {projects.map((project, index) => (
                    <ProjectCard key={`project-${index}`} index={index} {...project} />
                ))}
            </SkillsContainer>
        </CommonSection>
    );
};

export default Projects;

const SkillsContainer = styled(Grid)`
  grid-template-columns: repeat(3, 350px);
  column-gap: 3rem;
  justify-content: center;

  /* BREAKPOINTS */
  /* For large devices */
  @media screen and (max-width: 992px) {
    grid-template-columns: 650px;
    column-gap: 3rem;
  }

  /* For medium devices */
  @media screen and (max-width: 768px) {
    grid-template-columns: 400px;
    column-gap: 5rem;
  }

  /* For medium devices */
  @media screen and (max-width: 576px) {
    /* TODO: does not work */
    grid-template-columns: 1fr;
  }

  /* For small devices */
  @media screen and (max-width: 350px) {
  }
`;

